import React, { type ComponentType } from 'react';
import { Stack, Box } from '@atlaskit/primitives';

export type Props = {
	LinkSelector: ComponentType<{
		onAdd: () => void;
	}>;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	PagesSelector: ComponentType<Record<any, any>>;
	RepositorySelector: ComponentType<{
		onAdd: () => void;
	}>;
	showLinkSelector: boolean;
	showPagesSelector: boolean;
	showRepositorySelector: boolean;
	onAddLink: () => void;
	onAddRepo: () => void;
};

export function Content(props: Props) {
	const {
		LinkSelector,
		PagesSelector,
		RepositorySelector,
		showLinkSelector,
		showPagesSelector,
		showRepositorySelector,
		onAddLink,
		onAddRepo,
	} = props;

	return (
		<Box
			paddingBlockStart="space.200"
			paddingInlineEnd="space.100"
			paddingBlockEnd="space.0"
			paddingInlineStart="space.200"
		>
			<Stack space="space.400">
				{showLinkSelector && <LinkSelector onAdd={onAddLink} />}
				{showRepositorySelector && <RepositorySelector onAdd={onAddRepo} />}
				{showPagesSelector && <PagesSelector />}
			</Stack>
		</Box>
	);
}

export default Content;
